<template>
  <div :class="$style.base">
    <InputElement
      v-model="value"
      :type="inputType"
      v-bind="{ uid, hasError, placeholder, disabled, focus, size, prefix, masked: masked && !visible }"
      :inputMode="inputMode"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
    />
    <VisibilityToggle
      v-if="masked && value"
      v-model="visible"
      :hasError="hasError"
      v-test="'_base-input-visibility-toggle'"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import InputElement from './_shared/InputElement.vue';
import props from './_shared/props';
import VisibilityToggle from './_shared/VisibilityToggle.vue';

const inputTypes = ['text', 'email', 'tel', 'url'];
const inputModes = ['text', 'email', 'tel', 'url', 'search'];

export default defineComponent({
  components: {
    InputElement,
    VisibilityToggle,
  },
  inheritAttrs: false,
  props: {
    modelValue: String,
    type: {
      type: String,
      required: true,
      validator: (value: string) => inputModes.indexOf(value) !== -1,
    },
    masked: Boolean,
    ...props(),
  },
  setup(props) {
    const visible = ref(!props.masked);
    return {
      visible,
    };
  },
  emits: ['update:modelValue', 'focus', 'blur'],
  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(value: string) {
        if (this.type === 'email') {
          this.$emit('update:modelValue', value.toLowerCase());
        } else {
          this.$emit('update:modelValue', value);
        }
      },
    },
    inputType() {
      return inputTypes.includes(this.type) ? this.type : 'text';
    },
    inputMode() {
      return inputModes.includes(this.type) ? this.type : 'text';
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  position: relative;
}
</style>
